import { memo } from "react";

import { Badge, MantineColor } from "@mantine/core";

interface IProps {
  outcome: string;
  className?: string;
}

const colorMap: Record<string, MantineColor> = {
  successful: "green",
  unsuccessful: "red",
  refield: "red",
  inconclusive: "yellow",
  "no difference": "yellow"
};

const titleMap: Record<string, string> = {
  successful: "Hypothesis Validated",
  unsuccessful: "Hypothesis Invalidated",
  refield: "Hypothesis Invalidated",
  inconclusive: "No Change",
  "no difference": "No Change"
};

const OutcomeChip = (props: IProps) => {
  const { outcome, className } = props;

  return (
    <Badge
      size="xs"
      tt="none"
      color={colorMap[outcome]}
      w={`${titleMap[outcome].length}ch`}
      miw={75}
      className={className}
    >
      {titleMap[outcome]}
    </Badge>
  );
};

export default memo(OutcomeChip);
